import axios from "axios";
import { useState, useEffect } from "react";
import PopularCard from "./PopularCard";

const url = process.env.REACT_APP_API_URL + "/products";

function Popular() {
  const [products, setProducts] = useState([]);

  const getProducts = async () => {
    const response = await axios.get(url);
    setProducts(response.data.products);
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <div className="container">
      <div>
        <h3>Hot Bevarages</h3>
        <hr />
        <div className="d-flex justify-content-around flex-wrap">
          {products.map((product) => {
            if (product.type === "Hot Beverage") {
              return <PopularCard key={product._id} {...product} />;
            }

            return null;
          })}
        </div>
        <br /><br />
        <h3>Daily Staples</h3>
        <hr />
        <div className="d-flex justify-content-around flex-wrap">
          {products.map((product) => {
            if (product.type === "Daily Staple") {
              return <PopularCard key={product._id} {...product} />;
            }

            return null;
          })}
        </div>
        <br /><br />
        <h3>Biscuits and Snacks</h3>
        <hr />
        <div className="d-flex justify-content-around flex-wrap">
          {products.map((product) => {
            if (product.type === "Biscuits" || product.type === "Snacks") {
              return <PopularCard key={product._id} {...product} />;
            }

            return null;
          })}
        </div>
        <br /><br />
      </div>
    </div>
  );
}

export default Popular;
